
/* ======================================================
   SEELENMATCH.JS — IDENTITY LAB ENGINE V2
   ------------------------------------------------------
   New engine:
   quiz answers -> user archetype primary/secondary
   portrait metadata -> portrait archetype
   user archetype + portrait archetype -> Rank 1 / Rank 2 / Rank 3

   Image naming:
   LETTER-sign-gender-age-origin-beauty.png

   Examples:
   A-aquarius-f-30-south-n.png
   G-libra-f-40-west-n.png
   M-cancer-m-50-north-n.png
====================================================== */

(function (window) {
  "use strict";

  const SM_CONFIG = {
    version: "identity_lab_v2_1",
    storageKeys: {
      identityPayload: "sm_identity_payload_v2",
      guidedResult: "sm_guided_result_v2",
      intuitiveResult: "sm_intuitive_result_v2"
    },
    imageBaseUrl: "https://portraits.seelenmatch.com/zodiac-r",
    imageFallbackBaseUrl: "https://portraits.seelenmatch.com/zodiac-t",
    defaultBeautyCode: "n",
    maxRanks: 3
  };

  const VALID_SIGNS = [
    "aries", "taurus", "gemini", "cancer", "leo", "virgo",
    "libra", "scorpio", "sagittarius", "capricorn", "aquarius", "pisces"
  ];

  const VALID_AGES = ["30", "40", "50", "60"];
  const VALID_ORIGINS = ["north", "west", "south"];

  const SERIES_LETTERS = {
    south: { m: ["A", "B", "C"], f: ["A"] },
    west:  { m: ["G", "H", "I"], f: ["G"] },
    north: { m: ["M", "N", "O"], f: ["M"] }
  };

  
  /* ======================================================
   1. USER ARCHETYPES (GERMAN DISPLAY VERSION)
====================================================== */

const USER_ARCHETYPES = {
  quiet_garden: {
    label: "Der Ruhige Garten",
    shortLabel: "Ruhiger Garten",
    description: "Stabil, ruhig, beschützend und auf emotionale Sicherheit ausgerichtet.",
    keywords: ["home", "calm", "peace", "stability", "routine", "family"]
  },

  midnight_wanderer: {
    label: "Der Mitternachtswanderer",
    shortLabel: "Mitternachtswanderer",
    description: "Frei, spontan, nachtaktiv und angezogen von Bewegung und Überraschung.",
    keywords: ["night", "freedom", "movement", "spontaneity", "independence"]
  },

  golden_anchor: {
    label: "Der Goldene Anker",
    shortLabel: "Goldener Anker",
    description: "Loyal, verbindlich und auf der Suche nach einer stabilen und ernsthaften Verbindung.",
    keywords: ["loyalty", "commitment", "security", "protection", "family"]
  },

  burning_horizon: {
    label: "Der Brennende Horizont",
    shortLabel: "Brennender Horizont",
    description: "Abenteuerlustig, leidenschaftlich und emotional intensiv.",
    keywords: ["adventure", "travel", "passion", "movement", "intensity"]
  },

  hidden_fire: {
    label: "Das Verborgene Feuer",
    shortLabel: "Verborgenes Feuer",
    description: "Tiefgründig, diskret und innerlich intensiv, auf der Suche nach einer seltenen emotionalen Verbindung.",
    keywords: ["depth", "discretion", "inner intensity", "rare connection"]
  },

  velvet_storm: {
    label: "Der Samtsturm",
    shortLabel: "Samtsturm",
    description: "Magnetisch, intensiv und von sofortiger emotionaler Chemie angezogen.",
    keywords: ["chemistry", "passion", "magnetism", "intensity"]
  },

  forgotten_poet: {
    label: "Der Vergessene Poet",
    shortLabel: "Vergessener Poet",
    description: "Künstlerisch, nachdenklich und angezogen von Tiefe und geistiger Verbindung.",
    keywords: ["art", "mind", "beauty", "meaning", "creativity"]
  },

  iron_heart: {
    label: "Das Eiserne Herz",
    shortLabel: "Eisernes Herz",
    description: "Rational, selektiv und auf der Suche nach Respekt, Klarheit und Stabilität.",
    keywords: ["logic", "selection", "structure", "control", "respect"]
  }
};

/* ======================================================
   2. PORTRAIT ARCHETYPES (GERMAN DISPLAY VERSION)
====================================================== */

const PORTRAIT_ARCHETYPES = {
  winter_letter: {
    label: "Der Winterbrief",
    shortLabel: "Winterbrief",
    description: "Ruhig, reserviert, stabil und emotional ausgeglichen.",
    keywords: ["calm", "reserved", "stable", "north", "quiet"]
  },

  southern_echo: {
    label: "Das Südliche Echo",
    shortLabel: "Südliches Echo",
    description: "Warmherzig, offen, spontan und emotional zugänglich.",
    keywords: ["warm", "social", "open", "south", "spontaneous"]
  },

  hidden_lighthouse: {
    label: "Der Verborgene Leuchtturm",
    shortLabel: "Verborgener Leuchtturm",
    description: "Beschützend, zuverlässig und ruhig stark ohne dominant zu wirken.",
    keywords: ["protective", "reliable", "stable", "quiet strength"]
  },

  burning_horizon: {
    label: "Der Brennende Horizont",
    shortLabel: "Brennender Horizont",
    description: "Charismatisch, abenteuerlustig und voller emotionaler Intensität.",
    keywords: ["charismatic", "adventure", "movement", "intensity"]
  },

  forgotten_poet: {
    label: "Der Vergessene Poet",
    shortLabel: "Vergessener Poet",
    description: "Sensibel, künstlerisch, introspektiv und emotional tiefgründig.",
    keywords: ["artistic", "sensitive", "deep", "introspective"]
  },

  gentle_storm: {
    label: "Der Sanfte Sturm",
    shortLabel: "Sanfter Sturm",
    description: "Leidenschaftlich und intensiv, aber zugleich weich und warm.",
    keywords: ["passion", "softness", "intensity", "warmth"]
  },

  autumn_promise: {
    label: "Das Herbstversprechen",
    shortLabel: "Herbstversprechen",
    description: "Reif, loyal, stabil und auf langfristige Bindung ausgerichtet.",
    keywords: ["mature", "stable", "loyal", "long-term"]
  },

  midnight_passenger: {
    label: "Der Mitternachtsreisende",
    shortLabel: "Mitternachtsreisender",
    description: "Geheimnisvoll, nachtaktiv und emotional neugierig.",
    keywords: ["mystery", "night", "curiosity", "unpredictable"]
  }
};


  /* ======================================================
     3. QUIZ QUESTIONS + SCORING RULES
  ====================================================== */

  const QUIZ_QUESTIONS = [
    {
      id: "lifestyle",
      title: "Welcher Lebensrhythmus beschreibt dich am besten?",
      options: [
        { value: "home_lover", label: "Ich liebe ein ruhiges Zuhause" },
        { value: "night_owl", label: "Ich bin eher ein Nachtmensch" },
        { value: "traveler", label: "Ich brauche Bewegung und Reisen" },
        { value: "career_builder", label: "Ich bin zielorientiert und baue etwas auf" },
        { value: "artistic_life", label: "Ich brauche Kreativität und Tiefe" },
        { value: "calm_routine", label: "Ich mag einen ruhigen, klaren Alltag" }
      ]
    },
    {
      id: "relationship_rhythm",
      title: "Wie entsteht für dich eine echte Verbindung?",
      options: [
        { value: "slow_deep", label: "Langsam, tief und mit Vertrauen" },
        { value: "fast_intense", label: "Schnell, intensiv und spürbar" },
        { value: "stable_secure", label: "Stabil, sicher und verlässlich" },
        { value: "independent_connected", label: "Frei, aber verbunden" },
        { value: "passionate_spontaneous", label: "Leidenschaftlich und spontan" }
      ]
    },
    {
      id: "emotional_attraction",
      title: "Welche Präsenz zieht dich emotional am stärksten an?",
      options: [
        { value: "calm", label: "Ruhig" },
        { value: "protective", label: "Beschützend" },
        { value: "adventurous", label: "Abenteuerlich" },
        { value: "intellectual", label: "Intellektuell" },
        { value: "artistic", label: "Künstlerisch" },
        { value: "passionate", label: "Leidenschaftlich" }
      ]
    },
    {
      id: "future_projection",
      title: "In welche Zukunft kannst du dich am leichtesten hineinfühlen?",
      options: [
        { value: "family", label: "Familie und Verlässlichkeit" },
        { value: "travel", label: "Reisen und Entdecken" },
        { value: "freedom", label: "Freiheit und persönlicher Raum" },
        { value: "stability", label: "Stabilität und Frieden" },
        { value: "creation", label: "Kreativität und Sinn" },
        { value: "success", label: "Erfolg und klare Ziele" }
      ]
    },
    {
      id: "hidden_desire",
      title: "Was suchst du vielleicht tiefer, als du es direkt sagen würdest?",
      options: [
        { value: "rare_connection", label: "Eine seltene Verbindung" },
        { value: "security", label: "Sicherheit" },
        { value: "passion", label: "Leidenschaft" },
        { value: "adventure", label: "Abenteuer" },
        { value: "peace", label: "Frieden" },
        { value: "independence", label: "Unabhängigkeit" }
      ]
    }
  ];

  const QUIZ_RULES = {
    lifestyle: {
      home_lover: { quiet_garden: 3, golden_anchor: 2 },
      night_owl: { midnight_wanderer: 3, velvet_storm: 2 },
      traveler: { burning_horizon: 3, midnight_wanderer: 2 },
      career_builder: { iron_heart: 3, golden_anchor: 1 },
      artistic_life: { forgotten_poet: 3, hidden_fire: 2 },
      calm_routine: { quiet_garden: 3, hidden_fire: 2 }
    },
    relationship_rhythm: {
      slow_deep: { hidden_fire: 3, quiet_garden: 2 },
      fast_intense: { velvet_storm: 3, burning_horizon: 2 },
      stable_secure: { golden_anchor: 3, quiet_garden: 2 },
      independent_connected: { midnight_wanderer: 3, iron_heart: 2 },
      passionate_spontaneous: { burning_horizon: 3, velvet_storm: 2 }
    },
    emotional_attraction: {
      calm: { quiet_garden: 3, hidden_fire: 1 },
      protective: { golden_anchor: 3, quiet_garden: 1 },
      adventurous: { burning_horizon: 3, midnight_wanderer: 1 },
      intellectual: { iron_heart: 3, forgotten_poet: 2 },
      artistic: { forgotten_poet: 3, hidden_fire: 1 },
      passionate: { velvet_storm: 3, burning_horizon: 1 }
    },
    future_projection: {
      family: { golden_anchor: 3, quiet_garden: 2 },
      travel: { burning_horizon: 3, midnight_wanderer: 1 },
      freedom: { midnight_wanderer: 3, iron_heart: 1 },
      stability: { quiet_garden: 3, golden_anchor: 1 },
      creation: { forgotten_poet: 3, hidden_fire: 1 },
      success: { iron_heart: 3, golden_anchor: 1 }
    },
    hidden_desire: {
      rare_connection: { hidden_fire: 3, forgotten_poet: 1 },
      security: { golden_anchor: 3, quiet_garden: 1 },
      passion: { velvet_storm: 3, burning_horizon: 1 },
      adventure: { burning_horizon: 3, midnight_wanderer: 1 },
      peace: { quiet_garden: 3, hidden_fire: 1 },
      independence: { midnight_wanderer: 3, iron_heart: 1 }
    }
  };

  /* ======================================================
     4. MATCHING MATRIX
     User archetype -> portrait archetype weights
  ====================================================== */

  const MATCHING_MATRIX = {
    quiet_garden: {
      hidden_lighthouse: 100, autumn_promise: 92, winter_letter: 86,
      forgotten_poet: 72, gentle_storm: 62, southern_echo: 54,
      burning_horizon: 42, midnight_passenger: 34
    },
    midnight_wanderer: {
      midnight_passenger: 100, burning_horizon: 92, southern_echo: 84,
      gentle_storm: 72, forgotten_poet: 62, winter_letter: 50,
      hidden_lighthouse: 42, autumn_promise: 34
    },
    golden_anchor: {
      hidden_lighthouse: 100, autumn_promise: 96, winter_letter: 82,
      southern_echo: 64, gentle_storm: 58, forgotten_poet: 54,
      burning_horizon: 40, midnight_passenger: 30
    },
    burning_horizon: {
      burning_horizon: 100, southern_echo: 92, gentle_storm: 84,
      midnight_passenger: 78, forgotten_poet: 62, autumn_promise: 48,
      hidden_lighthouse: 42, winter_letter: 36
    },
    hidden_fire: {
      forgotten_poet: 100, winter_letter: 92, hidden_lighthouse: 84,
      gentle_storm: 72, autumn_promise: 68, midnight_passenger: 56,
      southern_echo: 48, burning_horizon: 44
    },
    velvet_storm: {
      gentle_storm: 100, burning_horizon: 92, midnight_passenger: 86,
      southern_echo: 76, forgotten_poet: 62, hidden_lighthouse: 50,
      autumn_promise: 42, winter_letter: 36
    },
    forgotten_poet: {
      forgotten_poet: 100, winter_letter: 88, gentle_storm: 78,
      hidden_lighthouse: 72, midnight_passenger: 68, autumn_promise: 58,
      southern_echo: 52, burning_horizon: 46
    },
    iron_heart: {
      winter_letter: 100, hidden_lighthouse: 92, autumn_promise: 84,
      forgotten_poet: 76, gentle_storm: 54, southern_echo: 48,
      midnight_passenger: 42, burning_horizon: 36
    }
  };

  /* ======================================================
     5. PORTRAIT ARCHETYPE RULES
  ====================================================== */

  const PORTRAIT_RULES = {
    originBase: {
      north: ["winter_letter", "hidden_lighthouse", "autumn_promise"],
      west: ["forgotten_poet", "midnight_passenger", "gentle_storm"],
      south: ["southern_echo", "burning_horizon", "gentle_storm"]
    },
    ageBias: {
      "30": ["burning_horizon", "midnight_passenger", "southern_echo"],
      "40": ["hidden_lighthouse", "forgotten_poet", "gentle_storm"],
      "50": ["autumn_promise", "hidden_lighthouse", "forgotten_poet"],
      "60": ["winter_letter", "autumn_promise", "hidden_lighthouse"]
    },
    letterBias: {
      A: "southern_echo", B: "burning_horizon", C: "gentle_storm",
      G: "forgotten_poet", H: "midnight_passenger", I: "gentle_storm",
      M: "winter_letter", N: "hidden_lighthouse", O: "autumn_promise"
    },
    signVariation: {
      aries: "burning_horizon",
      taurus: "autumn_promise",
      gemini: "midnight_passenger",
      cancer: "hidden_lighthouse",
      leo: "southern_echo",
      virgo: "winter_letter",
      libra: "gentle_storm",
      scorpio: "gentle_storm",
      sagittarius: "burning_horizon",
      capricorn: "winter_letter",
      aquarius: "forgotten_poet",
      pisces: "forgotten_poet"
    }
  };

  /* ======================================================
     6. HELPERS
  ====================================================== */

  function clone(value) {
    return JSON.parse(JSON.stringify(value));
  }

  function normalizeGender(value) {
    const v = String(value || "").trim().toLowerCase();
    if (["f", "female", "frau", "woman", "women"].includes(v)) return "f";
    return "m";
  }

  function normalizeAge(value) {
    const v = String(value || "").trim().toLowerCase();
    if (VALID_AGES.includes(v)) return v;
    if (["25-34", "25_34", "30-39", "30_39"].includes(v)) return "30";
    if (["35-44", "35_44", "40-49", "40_49"].includes(v)) return "40";
    if (["45-54", "45_54", "50-59", "50_59"].includes(v)) return "50";
    if (["55-64", "55_64", "60-69", "60_69"].includes(v)) return "60";

    const n = parseInt(v, 10);
    if (!Number.isNaN(n)) {
      if (n < 40) return "30";
      if (n < 50) return "40";
      if (n < 60) return "50";
      return "60";
    }
    return "40";
  }

  function normalizeOrigin(value) {
    const v = String(value || "").trim().toLowerCase();
    if (VALID_ORIGINS.includes(v)) return v;
    if (["nord", "northern"].includes(v)) return "north";
    if (["ouest", "western"].includes(v)) return "west";
    if (["sud", "southern"].includes(v)) return "south";
    return "west";
  }

  function normalizeOrigins(value) {
    if (!value) return [...VALID_ORIGINS];
    if (Array.isArray(value)) {
      const list = value
        .map(normalizeOrigin)
        .filter((item, index, arr) => arr.indexOf(item) === index);
      return list.length ? list : [...VALID_ORIGINS];
    }
    return [normalizeOrigin(value)];
  }

  function normalizeSigns(value) {
    if (!value) return [...VALID_SIGNS];
    if (Array.isArray(value)) {
      const list = value
        .map((item) => String(item || "").trim().toLowerCase())
        .filter((item) => VALID_SIGNS.includes(item))
        .filter((item, index, arr) => arr.indexOf(item) === index);
      return list.length ? list : [...VALID_SIGNS];
    }
    const v = String(value || "").trim().toLowerCase();
    return VALID_SIGNS.includes(v) ? [v] : [...VALID_SIGNS];
  }

  function getSeriesLetters(origin, gender) {
    const source = SERIES_LETTERS[normalizeOrigin(origin)] || SERIES_LETTERS.west;
    return source[normalizeGender(gender)] || source.m || ["G"];
  }

  function createEmptyUserScores() {
    const scores = {};
    Object.keys(USER_ARCHETYPES).forEach((key) => {
      scores[key] = 0;
    });
    return scores;
  }

  function addScores(scores, additions) {
    if (!additions) return;
    Object.entries(additions).forEach(([key, value]) => {
      if (Object.prototype.hasOwnProperty.call(scores, key)) {
        scores[key] += Number(value) || 0;
      }
    });
  }

  function sortScores(scores) {
    return Object.entries(scores)
      .map(([key, score]) => ({
        key,
        score,
        archetype: USER_ARCHETYPES[key]
      }))
      .sort((a, b) => b.score - a.score);
  }

  function buildImageId(letter, sign, gender, age, origin, beauty) {
    return `${letter}-${sign}-${gender}-${age}-${origin}-${beauty}`;
  }

  function buildImageUrl(baseUrl, id) {
    return `${baseUrl}/${id}.png`;
  }

  function shuffle(items) {
    const arr = [...items];
    for (let i = arr.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }

  /* ======================================================
     7. USER ARCHETYPE ENGINE
  ====================================================== */

  function calculateUserArchetype(answers = {}) {
    const scores = createEmptyUserScores();

    Object.entries(QUIZ_RULES).forEach(([questionId, answerRules]) => {
      const selectedValue = answers[questionId];
      if (!selectedValue) return;
      addScores(scores, answerRules[selectedValue]);
    });

    const sorted = sortScores(scores);
    const primary = sorted[0] || null;
    const secondary = sorted[1] || null;

    return {
      scores,
      sorted,
      primaryKey: primary ? primary.key : null,
      secondaryKey: secondary ? secondary.key : null,
      primary: primary ? USER_ARCHETYPES[primary.key] : null,
      secondary: secondary ? USER_ARCHETYPES[secondary.key] : null
    };
  }

  function buildIdentityPayload(answers = {}, meta = {}) {
    const userArchetype = calculateUserArchetype(answers);

    return {
      version: SM_CONFIG.version,
      createdAt: new Date().toISOString(),
      answers: clone(answers),
      meta: {
        gender: normalizeGender(meta.gender || answers.gender || answers.sm_gender),
        targetGender: normalizeGender(meta.targetGender || answers.targetGender || answers.gender || answers.sm_gender),
        age: normalizeAge(meta.age || answers.age || answers.sm_agepref),
        preferredOrigins: normalizeOrigins(meta.preferredOrigins || answers.preferredOrigins || answers.origin || answers.sm_ethnicity),
        signs: normalizeSigns(meta.signs || answers.signs || answers.previewSigns)
      },
      userArchetype
    };
  }

  function saveIdentityPayload(payload) {
    localStorage.setItem(SM_CONFIG.storageKeys.identityPayload, JSON.stringify(payload));
    return payload;
  }

  function readIdentityPayload() {
    try {
      const raw = localStorage.getItem(SM_CONFIG.storageKeys.identityPayload);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  /* ======================================================
     8. PORTRAIT ARCHETYPE ENGINE
  ====================================================== */

  function choosePortraitArchetype(profile) {
    const candidates = {};

    function add(key, points) {
      if (!key || !PORTRAIT_ARCHETYPES[key]) return;
      candidates[key] = (candidates[key] || 0) + points;
    }

    const originBase = PORTRAIT_RULES.originBase[profile.origin] || [];
    const ageBias = PORTRAIT_RULES.ageBias[profile.age] || [];
    const letterBias = PORTRAIT_RULES.letterBias[profile.letter] || null;
    const signBias = PORTRAIT_RULES.signVariation[profile.sign] || null;

    originBase.forEach((key, index) => add(key, 6 - index));
    ageBias.forEach((key, index) => add(key, 4 - index));
    add(letterBias, 8);
    add(signBias, 2);

    const sorted = Object.entries(candidates).sort((a, b) => b[1] - a[1]);
    return sorted.length ? sorted[0][0] : "forgotten_poet";
  }

  function buildPortraitPool(options = {}) {
    const gender = normalizeGender(options.targetGender || options.gender || "m");
    
function getClosestAges(age) {
  const normalizedAge = parseInt(age, 10) || 40;

  if (normalizedAge <= 34) return ["30", "40"];
  if (normalizedAge <= 44) return ["40", "30"];
  if (normalizedAge <= 54) return ["50", "40"];

  return ["60", "50"];
}

const ages = Array.isArray(options.ages)
  ? options.ages.map(normalizeAge).filter((item, index, arr) => arr.indexOf(item) === index)
  : getClosestAges(options.age || "40");
  

    const origins = normalizeOrigins(options.origins || options.preferredOrigins || options.origin);
    const signs = normalizeSigns(options.signs || options.previewSigns);
    const beauty = options.beautyCode || SM_CONFIG.defaultBeautyCode;

    const pool = [];

    signs.forEach((sign) => {
      ages.forEach((age) => {
        origins.forEach((origin) => {
          getSeriesLetters(origin, gender).forEach((letter) => {
            const id = buildImageId(letter, sign, gender, age, origin, beauty);

            const baseProfile = {
              id,
              letter,
              sign,
              gender,
              age,
              origin,
              beauty,
              image: buildImageUrl(SM_CONFIG.imageBaseUrl, id),
              fallbackImage: buildImageUrl(SM_CONFIG.imageFallbackBaseUrl, id)
            };

            const portraitArchetypeKey = choosePortraitArchetype(baseProfile);

            pool.push({
              ...baseProfile,
              portraitArchetypeKey,
              portraitArchetype: PORTRAIT_ARCHETYPES[portraitArchetypeKey]
            });
          });
        });
      });
    });

    return pool;
  }

  /* ======================================================
     9. MATCHING ENGINE
  ====================================================== */

  function scorePortraitForUser(profile, identityPayload) {
    const primaryKey = identityPayload?.userArchetype?.primaryKey;
    const secondaryKey = identityPayload?.userArchetype?.secondaryKey;
    const portraitKey = profile.portraitArchetypeKey;

    const primaryScore = MATCHING_MATRIX[primaryKey]?.[portraitKey] || 0;
    const secondaryScore = MATCHING_MATRIX[secondaryKey]?.[portraitKey] || 0;

    let score = primaryScore * 0.72 + secondaryScore * 0.28;

    if (identityPayload?.meta?.preferredOrigins?.includes(profile.origin)) {
      score += 1;
    }

    if (identityPayload?.meta?.age === profile.age) {
      score += 0.5;
    }

    return Math.round(score);
  }

  function buildRankExplanation(rank, profile, identityPayload) {
    const userPrimary = identityPayload?.userArchetype?.primary?.label || "your primary profile";
    const userSecondary = identityPayload?.userArchetype?.secondary?.label || "your secondary profile";
    const portraitLabel = profile?.portraitArchetype?.label || "this portrait";

    if (rank === 1) {
      return `${portraitLabel} is the strongest match for ${userPrimary}. It reflects the main emotional direction shown by your answers.`;
    }

    if (rank === 2) {
      return `${portraitLabel} is a second possible connection. It resonates more with the secondary side of your profile: ${userSecondary}.`;
    }

    return `${portraitLabel} is an alternative match. It may not be the most obvious profile, but it opens a different emotional possibility.`;
  }

  function rankPortraits(identityPayload, portraitPool, options = {}) {
    const maxRanks = options.maxRanks || SM_CONFIG.maxRanks;

    const scored = portraitPool
      .map((profile) => ({
        ...profile,
        matchScore: scorePortraitForUser(profile, identityPayload)
      }))
      .sort((a, b) => b.matchScore - a.matchScore);

    const ranks = [];
    const usedPortraitArchetypes = new Set();

    scored.forEach((profile) => {
      if (ranks.length >= maxRanks) return;
      if (usedPortraitArchetypes.has(profile.portraitArchetypeKey)) return;

      ranks.push(profile);
      usedPortraitArchetypes.add(profile.portraitArchetypeKey);
    });

    scored.forEach((profile) => {
      if (ranks.length >= maxRanks) return;
      if (ranks.some((item) => item.id === profile.id)) return;
      ranks.push(profile);
    });

    return ranks.map((profile, index) => ({
      ...profile,
      rank: index + 1,
      rankLabel: `Rank ${index + 1}`,
      explanation: buildRankExplanation(index + 1, profile, identityPayload)
    }));
  }

  function buildGuidedResult(answers = {}, meta = {}) {
    const identityPayload = buildIdentityPayload(answers, meta);

    const pool = buildPortraitPool({
      targetGender: identityPayload.meta.targetGender,
      age: identityPayload.meta.age,
      origins: identityPayload.meta.preferredOrigins,
      signs: identityPayload.meta.signs,
      beautyCode: SM_CONFIG.defaultBeautyCode
    });

    const ranks = rankPortraits(identityPayload, pool, {
      maxRanks: SM_CONFIG.maxRanks
    });

    const result = {
      version: SM_CONFIG.version,
      createdAt: new Date().toISOString(),
      identityPayload,
      ranks
    };

    saveIdentityPayload(identityPayload);
    localStorage.setItem(SM_CONFIG.storageKeys.guidedResult, JSON.stringify(result));

    return result;
  }

  /* ======================================================
     10. INTUITIVE SUPPORT
  ====================================================== */

  function buildIntuitivePoolFromIdentity(identityPayload, options = {}) {
    return buildPortraitPool({
      targetGender: options.targetGender || identityPayload?.meta?.targetGender || "m",
      age: options.age || identityPayload?.meta?.age || "40",
      origins: options.origins || identityPayload?.meta?.preferredOrigins || VALID_ORIGINS,
      signs: options.signs || identityPayload?.meta?.signs || VALID_SIGNS,
      beautyCode: options.beautyCode || SM_CONFIG.defaultBeautyCode
    });
  }

  function analyzeIntuitiveSelection(identityPayload, selectedProfile, pool = []) {
    const selectedScore = scorePortraitForUser(selectedProfile, identityPayload);
    const expectedTop = rankPortraits(identityPayload, pool, { maxRanks: 3 });

    const isAlignedWithGuided = expectedTop.some(
      (item) => item.portraitArchetypeKey === selectedProfile.portraitArchetypeKey
    );

    const userLabel = identityPayload?.userArchetype?.primary?.label || "your primary profile";
    const selectedLabel = selectedProfile?.portraitArchetype?.label || "this portrait";

    return {
      selectedProfile,
      selectedScore,
      expectedTop,
      isAlignedWithGuided,
      insight: isAlignedWithGuided
        ? `Your intuitive choice is aligned with ${userLabel}. You were naturally drawn to ${selectedLabel}.`
        : `Your intuitive choice reveals a tension: your answers point toward ${userLabel}, but your visual instinct was drawn to ${selectedLabel}.`
    };
  }

  /* ======================================================
     PUBLIC API
  ====================================================== */

  window.SeelenmatchEngineV2 = {
    config: SM_CONFIG,

    userArchetypes: USER_ARCHETYPES,
    portraitArchetypes: PORTRAIT_ARCHETYPES,
    quizQuestions: QUIZ_QUESTIONS,

    quizRules: QUIZ_RULES,
    portraitRules: PORTRAIT_RULES,
    matchingMatrix: MATCHING_MATRIX,

    calculateUserArchetype,
    buildIdentityPayload,
    saveIdentityPayload,
    readIdentityPayload,

    buildPortraitPool,
    choosePortraitArchetype,

    scorePortraitForUser,
    rankPortraits,
    buildGuidedResult,

    buildIntuitivePoolFromIdentity,
    analyzeIntuitiveSelection,

    helpers: {
      normalizeGender,
      normalizeAge,
      normalizeOrigin,
      normalizeOrigins,
      normalizeSigns,
      getSeriesLetters,
      buildImageId,
      buildImageUrl,
      shuffle
    }
  };
})(window);
